import { FluidTemperature, Fragments } from "requests";

export const isRequiredInfoFilled = (
  medCase: Fragments.StoredMedicalCase | undefined
) =>
  !!medCase &&
  medCase.client.patient.weight !== null &&
  medCase.client.patient.species !== null;

export const getVolumeInfused = (
  fluidTemperatures: FluidTemperature[],
  volumeToBeInfused: number | null
) => {
  if (volumeToBeInfused === null) {
    return null;
  }
  const sortedArr = fluidTemperatures
    ?.map(el => ({ ...el, timeMonitoring: new Date(el.timeMonitoring) }))
    ?.sort((a, b) => a.timeMonitoring.getTime() - b.timeMonitoring.getTime());

  return sortedArr?.length
    ? (sortedArr[0]?.volumeToBeInfused || 0) - volumeToBeInfused
    : 0;
};
